/** Lista limpa de estoques permitidos. Vazia significa "todos". */
export function estoquesPermitidos(perfil) {
    const lista = perfil?.allowedInventories;
    if (!Array.isArray(lista))
        return [];
    return lista.map(String).filter((id) => id.trim() !== '');
}
/** `true` quando o usuário tem a lista aberta — enxerga tudo. */
export function semRestricaoDeEstoque(perfil, papel) {
    return papel === 'master' || estoquesPermitidos(perfil).length === 0;
}
export function podeAcessarEstoque(perfil, papel, inventoryId) {
    if (semRestricaoDeEstoque(perfil, papel))
        return true;
    return estoquesPermitidos(perfil).includes(inventoryId);
}
/**
 * Filtra a lista de estoques pelo que o usuário pode ver.
 *
 * Se a restrição não deixar nenhum estoque de pé — porque os permitidos foram apagados,
 * por exemplo — devolve a lista inteira. Melhor mostrar tudo que deixar o app sem estoque
 * nenhum e o funcionário sem conseguir trabalhar; e o caso é raro o bastante para não
 * valer uma tela de erro.
 */
export function filtrarEstoquesPermitidos(estoques, perfil, papel) {
    if (semRestricaoDeEstoque(perfil, papel))
        return [...estoques];
    const permitidos = new Set(estoquesPermitidos(perfil));
    const filtrados = estoques.filter((e) => permitidos.has(e.id));
    return filtrados.length > 0 ? filtrados : [...estoques];
}
//# sourceMappingURL=acesso-estoque.js.map